<template>
  <div>
    <v-dialog fullscreen v-model="modal" persistent>
      <v-card>
        <v-toolbar color="primary" dark tabs>
          <v-toolbar-title>{{getName(tournament ? tournament.name : '')}}</v-toolbar-title>
          <template v-slot:extension>
            <v-tabs v-model="active" color="primary" dark centered show-arrows slider-color="blue">
              <v-tab v-for="title in tabTitle" :key="title" ripple>{{ title}}</v-tab>
            </v-tabs>
          </template>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              v-if="tournament && tournament._id"
              icon
              dark
              :loading="$store.state.tournaments.loading"
              @click="$store.dispatch('tournaments/refresh', tournament._id)"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
            <v-btn @click="$emit('update:modal', false)" dark icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-tabs-items v-model="active">
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <tab-informacion :tournament="tournament" />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <tab-tabla :tournament="tournament" />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <template v-if="modal && tournamentId && tournament.showRanking">
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <tab-clasificacion />
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </template>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <tab-courses />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <tab-stats
                    :tournamentId="tournament._id"
                    :tournamentType="tournament.type"
                    :phases="tournament.phases"
                    :actId="tournament.act"
                    :users="tournament.users"
                    :teams="tournament.teams"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <tab-videos v-if="modal && tournamentId && active == 4" :matches="listMatches" />
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="$emit('update:modal', false)" color="primary" small>{{$t('cancel')}}</v-btn>
          <v-btn
            color="secondary"
            small
            v-if="can('edit', 'tournament', tournament) && active == 0"
            @click="$emit('edit')"
          >{{$t('edit')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import tabInformacion from './acceder/tabInformation'
import tabClasificacion from './acceder/tabClasification'
import tabTabla from './acceder/tabTable'
import tabStats from './acceder/tabStats'
import tabVideos from './acceder/tabVideos'
import tabCourses from './acceder/tabCourses'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'tabAcceder',
  components: {
    tabInformacion,
    tabTabla,
    tabClasificacion,
    tabStats,
    tabVideos,
    tabCourses
  },
  props: {
    modal: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      active: 0
    }
  },
  mounted() {
    if (this.tournament.stadiumId) {
      this.initAulas(this.tournament.stadiumId)
    }
  },
  watch: {
    tournament(val) {
      if (!val) this.active = 0
    },

    'tournament.stadiumId': function(val) {
      this.initAulas(val)
    }
  },
  methods: {
    ...mapActions({
      initAulas: 'pitches/setPortion'
    })
  },
  computed: {
    ...mapState({
      tournament: state => state.tournaments.selected,
      tournamentId: state => state.tournaments.idSelected,
      match: state => state.matches.matchSelected
    }),
    listMatches() {
      let result = []
      if (this.tournament.phases) {
        this.tournament.phases.forEach(itemPhase => {
          itemPhase.groups.forEach(itemGroup => {
            itemGroup.matches.forEach(item => result.push(item))
          })
        })
      }
      return result
    },
    tabTitle() {
      let tabTile = [this.$t('information'), this.$t('table')]
      if (this.modal && this.tournamentId && this.tournament.showRanking)
        tabTile.push(this.$t('clasification'))
      tabTile = tabTile.concat([
        this.$tc('course', 2),
        this.$t('stats'),
        this.$t('videos')
      ])
      return tabTile
    }
  }
}
</script>

<style scoped lang="scss">
</style>
